const createDateFromFormatted = date => {
    const newDate = date.split('-');
    return new Date(newDate[0], newDate[2], newDate[1]);
};

export default createDateFromFormatted;
